module.exports = __webpack_public_path__ + "img/dashboard.8477adaa.svg";